module.exports = __webpack_public_path__ + "media/assets/images/flags/bb-1652d2ad339ab64521d2844ddb29ba03.svg";